import { render, staticRenderFns } from "./SetPriceModal.vue?vue&type=template&id=4da900dc&"
import script from "./SetPriceModal.vue?vue&type=script&lang=js&"
export * from "./SetPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da900dc')) {
      api.createRecord('4da900dc', component.options)
    } else {
      api.reload('4da900dc', component.options)
    }
    module.hot.accept("./SetPriceModal.vue?vue&type=template&id=4da900dc&", function () {
      api.rerender('4da900dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/modals/SetPriceModal.vue"
export default component.exports